<template>
  <div class="app-main-inner tab-file-history">
    <div style="padding:5px 0 10px 0">
      <el-button no="1" type="primary" @click="toQuery(1)">{{ $t('FileHistory.Refresh') }}</el-button>
      <!--v-permission="['button_FileHistory_fileUpload']" 未生效 权限先不加上-->
      <el-button no="2" type="primary" :disabled="canUse" @click="cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
      <!--v-permission="['button_FileHistory_fileDelete']" 未生效 权限先不加上-->
      <el-button no="3" type="danger" :disabled="canUse" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
      <el-button no="4" type="primary" :disabled="canUse" @click="download">{{ $t('FileHistory.BatchDownload') }}</el-button>
      <el-button v-if="ingotUploadButton" no="5" type="primary" :disabled="canUse">{{ $t('FileHistory.ingotUpload') }}</el-button>
      <el-button v-if="ingotButton" no="6" type="primary" :disabled="canUse">{{ $t('FileHistory.ingotLog') }}</el-button>
    </div>
    <div :style="`flex-grow:1;height: ${gridHeight};`">
      <cargo-ag-grid
        config-module="190811"
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :is-sirui="cloudFile.isSirui"
      :other-param="this.otherParam"
      :file-history-jc="this.fileHistoryJc"
      @uploadDone="data => {updateSop(data);}"
    />
    <el-dialog
      v-if="isShowingDetailForm"
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="isShowingDetailForm"
      :title="showDetailTitle"
      append-to-body
      width="400px"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptionsFileDetail"
        :column-defs="columnDefsFileDetail"
        :row-data="rowDataFileDetail"
        style="width:100%;height: 300px"
        @gridReady="params=>gridApiFileDetail=params.api"
      />
    </el-dialog>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </div>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import { getFileList, saveMetaData } from '@/api/storage'
import { cacheName, cache } from '@/utils/cacheManager'
import { Project } from '@/class/model/pm/Project'
import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sortByMultiField } from '@/utils'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import pdf from 'vue-pdf'
import { changeSopForFinance } from '@/api/fileHistory'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'

export default {
  name: 'TabFileHistory',
  components: { cargoCloudFileUpload, CargoDialog, pdf, preViewFileDialog },
  props: {
    billPaymentUuid: { type: String, required: true },
    billPaymentState: { type: Number, required: true },
    inputBy: { type: Number, required: true },
    gridHeight: { type: String, default: '510px' },
    fileHistoryJc: { type: Boolean, default: false },
    uploadEnable: { type: Boolean, default: false } // 是否允许上传文件
  },
  data() {
    return {
      ingotButton: false,
      ingotUploadButton: false,
      user: {},
      storageURL: '',
      fileTypeMap: new Map(),
      docType: [],
      job: null,
      fileName: '',
      fileIdList: '',
      otherParam: {
        inputBy: this.inputBy,
        billPaymentUuid: this.billPaymentUuid
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileVersion'),
          field: 'fileVersion',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          width: 100,
          cellRenderer: params => {
            return this.fileTypeLabelFunction(params.data)
          }
        },
        {
          headerName: this.$t('FileHistory.invoiceFlag'),
          field: 'invoiceFlag',
          width: 100,
          cellRenderer: params => {
            const v = params.data && (params.data.invoiceFlag === '1' || params.data.invoiceFlag === 1)
              ? this.$t('FileHistory.invoiceFlag_Yes')
              : (params.data && (params.data.invoiceFlag === '0' || params.data.invoiceFlag === 0)
                ? this.$t('FileHistory.invoiceFlag_No')
                : '')
            const methodPath = this.documentManage.getPath('editInvoiceFlag')
            const text = v || '&nbsp;'
            return `<div onclick="${methodPath}('${params.data.fileId}')" style="cursor:pointer;color:blue;">${text}</div>`
          }
        },
        {
          headerName: this.$t('FileHistory.fileType'),
          field: 'fileFormat',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 100,
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.createdBy'),
          field: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('FileHistory.createdDate'),
          field: 'createDate',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.Details'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
            return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
          }
        },
        {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            let preview = ''
            const fileStr = params.data.fileName
            const location = fileStr.lastIndexOf('.')
            const type = fileStr.substring(location + 1, fileStr.length)
            if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'pdf' || type === 'xls' || type === 'xlsx') {
              const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
              preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
            }

            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">
                    ${this.$t('FileHistory.fileDownload')}
                    </a>` + preview
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      columnDefsFileDetail: [
        {
          headerName: this.$t('FileHistory.tagName'),
          field: 'key',
          width: 150
        },
        {
          headerName: this.$t('FileHistory.tagValue'),
          field: 'val',
          width: 200
        }
      ],
      rowDataFileDetail: [],
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'allLob',
        isSirui: true
      },
      isShowingDetailForm: false,
      showDetailTitle: '',
      documentManage: new DocumentManage(),
      isAllowedEdit: true,
      newFileIds: '', // 新上传文件的ids 用于推送泛微
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  computed: {
    canUse() {
      return this.uploadEnable ? !this.billPaymentUuid : (!(this.billPaymentUuid !== '' && this.billPaymentState === 0))
    }
  },
  created() {
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
    this.documentManage.set('editInvoiceFlag', function(fileId) {
      context.editInvoiceFlag(fileId)
    })
    this.checkStatus()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    // 获取文件后缀名
    getFileType(fileName) {
      const arr = fileName.split('.')
      return arr[arr.length - 1].toLowerCase()
    },
    closePreviewDialog() {
      this.pdfSrc = ''
      this.numPages = ''
      this.photoList = []
      this.officeFileUrl = ''
      this.previewFileData.visible = false
    },
    // 根据付款申请状态 决定是否可用按钮
    async checkStatus() {
      this.rowData = []
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.configMap = cache.config
      this.cloudFile.job.uuid = encodeURIComponent(this.billPaymentUuid)
      this.toQuery(1)
    },
    /* 转换文件类型中文名称*/
    fileTypeLabelFunction(data) {
      return (data.fileType && data.fileType.toLocaleUpperCase() === 'OTHER') ? this.$t('Clearing.Other') : (data.extendMetaData ? data.extendMetaData.documentName : '')
    },
    /* 文件大小转换*/
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    // 上穿成功回掉
    async updateSop(rowData) {
      await this.toQuery(1)
      try {
        if (this.rowData && this.rowData.length > 0) {
          this.changeSop(rowData)
        }
      } catch (e) {
        console.log(e)
      }
    },
    changeSop(rowData) {
      // 提取documentTypeUuid 多个由 , 拼接
      let documentTypeUuid = ''
      if (rowData) {
        for (const item of rowData) {
          if (documentTypeUuid) {
            documentTypeUuid += ','
          }
          documentTypeUuid += item.documentTypeUuid
        }
      }
      if (!documentTypeUuid || documentTypeUuid === 'undefined') {
        return
      }
      const objParams = {
        anyStr: this.billPaymentUuid, // 付款申请UUID
        anyStr1: documentTypeUuid, // 文件类型UUID
        anyStr2: 'billPayment' // 模块类型
      }
      changeSopForFinance(objParams)
    },
    // 把文件发送至泛微
    async uploadFileOnWeaver() {
      if (this.newFileIds === undefined || this.newFileIds === '') {
        return
      }
      const requestParams = {}
      requestParams.fileIds = this.newFileIds
      requestParams.billPaymentUuid = this.billPaymentUuid
      requestParams.userId = this.inputBy
      uploadFileToWeaver(requestParams).then(res => {
        console.log(res)
        if (res.data.result) {
          // 上传成功
          // this.$message.success(this.$t('Message.UploadSuccess'))
          this.$emit('reloadData')
        } else {
          // 上传失败
          // this.$message.warning(res.data.message)
          this.$emit('reloadData')
        }
      })
    },
    // 查询文件 fromType = 1 来自刷新  2来自上传成功回调
    async toQuery(fromType) {
      if (!this.cloudFile.job.uuid || this.cloudFile.job.uuid === undefined) {
        return
      }
      this.storageURL = this.configMap.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.billPaymentUuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        const files = Array.from(res.data, p => {
          const invoiceFlag = p.extendMetaData && (p.extendMetaData.invoiceFlag || p.extendMetaData.invoice_type || '')
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: '',
            invoiceFlag
          }
        })
        // 来自上传成功 哪些是新增的文件 ，记录ids 发送泛微更新付款申请
        // console.log(this.rowData)
        // this.newFileIds = ''
        // if (fromType === 2 && files.length > 0) {
        //   for (let i = 0; i < files.length; i++) {
        //     if (this.rowData && this.rowData.length > 0) {
        //       for (let j = 0; j < this.rowData.length; j++) {
        //         if (files[i].fileId === this.rowData[j].fileId) {
        //           break
        //         }
        //         if (j === this.rowData.length - 1) {
        //           if (this.newFileIds === '') {
        //             this.newFileIds = files[i].fileId
        //           } else {
        //             this.newFileIds = this.newFileIds + ',' + files[i].fileId
        //           }
        //         }
        //       }
        //     } else {
        //       if (this.newFileIds === '') {
        //         this.newFileIds = files[i].fileId
        //       } else {
        //         this.newFileIds = this.newFileIds + ',' + files[i].fileId
        //       }
        //     }
        //   }
        //   this.uploadFileOnWeaver()
        // }
        this.rowData = files
      })
      this.getFilesSucceedHandler()
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      this.rowData = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      let fatherFile = this.rowData[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < this.rowData.length; i++) {
        childFile = this.rowData[i]
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      this.rowData = source
    },
    onFileView(value) {
      var fileObject = this.rowData.find(x => x.fileId === value)
      // 测试 编辑保存
      // this.itemEditEndHandler(fileObject)

      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.user.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.user.userId) {
        this.$message.warning('你没有查看其它人上传或者打印的文件的权限.')
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === '其他') {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (result === null || result.length === 0) {
        return true
      }

      if (this.user.admin || parseInt(data.createdBy) === this.user.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.info('[' + data.fileName + ']文件不允许任何人查看或下载.')
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.info('你没有权限查看或下载[' + data.fileName + ']文件')
        return
      }
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    // 文件类型 编辑保存
    async itemEditEndHandler(item) {
      // TODO 前端界面grid 文件类型下拉框公共控件未开发  入参已组装
      const documentType = item.extendMetaData['documentType']
      const documentName = item.extendMetaData['documentName']
      const isShared = item.extendMetaData['isShared']
      const op = item.extendMetaData['op']
      const sales = item.extendMetaData['sales']
      const all = item.extendMetaData['other']
      const customer = item.extendMetaData['customer']
      const consignee = item.extendMetaData['consignee']
      const shipper = item.extendMetaData['shipper']
      const destinationAgent = item.extendMetaData['destinationAgent']
      const bookingAgent = item.extendMetaData['bookingAgent']
      const invoiceFlag = item.extendMetaData['invoiceFlag'] || item.invoiceFlag || ''
      const xmlParam = `<RequestObject>
      <fileId>${item.fileId}</fileId>
      <extendMetaData>
      <entry>
      <key>documentType</key>
      <value>${documentType}</value>
      </entry>
      <entry>
      <key>documentName</key>
      <value>${documentName}</value>
      </entry>
      <entry>
      <key>isShared</key>
      <value>${isShared}</value>
      </entry>
      <entry>
      <key>op</key>
      <value>${op}</value>
      </entry>
      <entry>
      <key>sales</key>
      <value>${sales}</value>
      </entry>
      <entry>
      <key>all</key>
      <value>${all}</value>
      </entry>
      <entry>
      <key>customer</key>
      <value>${customer}</value>
      </entry>
      <entry>
      <key>consignee</key>
      <value>${consignee}</value>
      </entry>
      <entry>
      <key>shipper</key>
      <value>${shipper}</value>
      </entry>
      <entry>
      <key>destinationAgent</key>
      <value>${destinationAgent}</value>
      </entry>
      <entry>
        <key>bookingAgent</key>
        <value>${bookingAgent}</value>
        </entry>
      <entry>
        <key>invoiceFlag</key>
        <value>${invoiceFlag}</value>
        </entry>
        </extendMetaData>
        </RequestObject>`
      try {
        await saveMetaData(xmlParam)
      } catch (e) {
        this.$message.error(this.$t('FileHistory.saveFailed'))
      }
    },
    async editInvoiceFlag(fileId) {
      const item = this.rowData.find(x => x.fileId === fileId)
      if (!item) {
        return
      }
      try {
        const action = await this.$confirm(
          this.$t('FileHistory.invoiceFlag'),
          this.$t('common.tips.prompt'),
          {
            confirmButtonText: this.$t('FileHistory.invoiceFlag_Yes'),
            cancelButtonText: this.$t('FileHistory.invoiceFlag_No'),
            distinguishCancelAndClose: true,
            type: 'warning'
          }
        )
        if (action === 'confirm') {
          item.invoiceFlag = '1'
        }
      } catch (e) {
        if (e === 'cancel') {
          item.invoiceFlag = '0'
        } else {
          return
        }
      }
      if (!item.extendMetaData) {
        item.extendMetaData = {}
      }
      item.extendMetaData.invoiceFlag = item.invoiceFlag
      this.itemEditEndHandler(item)
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.SureYouWantToDeleteFilesTwo', [rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        const requestParams = {}
        for (let i = 0; i < rows.length; i++) {
          if (requestParams.fileIds === undefined || requestParams.fileIds === '') {
            requestParams.fileIds = rows[i].fileId
          } else {
            requestParams.fileIds = requestParams.fileIds + ',' + rows[i].fileId
          }
        }
        requestParams.billPaymentUuid = this.billPaymentUuid
        requestParams.userId = this.inputBy
        deleteFileToWeaver(requestParams).then(async res => {
          console.log(res)
          if (res.data.result) {
            // 删除成功
            this.$message.success(this.$t('Message.DeleteSuccessfully'))
            await this.toQuery(1)
          } else {
            // 删除失败
            this.$message.warning(res.data.message)
          }
        })
      }).catch(() => {
      })
    },
    download() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // 判断是否有权限
      this.validate(rows)
      if (rows.length === 1) {
        window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.user.sessionId}`)
      } else {
        const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
        const fileName = this.cloudFile.job.projectName + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.user.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
      }
    },
    validate(fileList) {
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        for (const file of fileList) {
          if (!this.checkDownloadFile(file)) {
            return false
          }
        }
      }
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          return this.checkFileDocTypeRole(file)
        }
      }
      return
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.isShowingDetailForm = true
      var fileObject = this.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent']

      var docTypeFilter = null
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        var documentType = extendMetaData.documentType
        if (documentType === '其他') {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (var key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        var keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t(`SeaExport.Accessible`) : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        var keyName
        keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = '订舱代理'
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.rowDataFileDetail = tempFileDetailList
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (var i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      var codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        var docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    /* json 根据 key 的名称排序的函数*/
    objKeySort(obj) {
      var newkey = Object.keys(obj).sort()
      var newObj = {}
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]]
      }
      return newObj
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      var convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
      }
      return convertKeyName
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-img{
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    max-width: 100%;
    min-width: 120px;
    min-height: 120px;
    height: auto;
  }
}
.pdf-img{
  height: 450px;
  .el-scrollbar{
    height: 450px;
    /deep/ .el-scrollbar__wrap{
      overflow-x: hidden;
    }
    /deep/ .el-scrollbar__bar{
      opacity: 1;
    }
  }
}
.office-preview {
  width: 100%;
  height: 100%;
  min-height: 600px;
  border: none;
}
.tab-file-history ::v-deep {
  .preview-dialog.is-fullscreen {
    height: 100%;
    .el-dialog__body {
      height: 100%;
      .pdf-img{
        height: 100%;
        .el-scrollbar{
          height: 100%;
        }
      }
    }
  }
}
</style>
